import { extend, override } from "flarum/common/extend";
import UserCard from 'flarum/forum/components/UserCard';
import setting from '../helpers/setting';

export default function () {
  extend(UserCard.prototype, 'infoItems', function (items) {
    const placeholder = setting('pointsPlaceholder');
    const pts = String(this.attrs.user.data.attributes.AdvPoints);
    const ptsMonthly = String(this.attrs.user.data.attributes.AdvPointsMonthly);
    // console.log(pts, placeholder, this.attrs.user.data.attributes);

    let points;

    if (placeholder) {
      points = <div className="userProfilePoints"><span>{placeholder.replace('{points}', '')}</span><span>{pts}</span><sub>({ptsMonthly})</sub></div>;
    } else {
      points = app.translator.trans('fof-gamification.forum.user.points', { points: pts });
    }
    items.add('advPoints', points, 100);
  });
};
